// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const celebi: PokeData = {
  "id": 251,
  "name": "celebi",
  "height": 6,
  "weight": 50,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC,
    PokeType.GRASS
  ],
  "api_moves": [
    "leech-seed",
    "confusion",
    "recover",
    "perish-song",
    "heal-bell",
    "safeguard",
    "baton-pass",
    "ancient-power",
    "future-sight",
    "magical-leaf",
    "healing-wish",
    "natural-gift",
    "heal-block",
    "leaf-storm",
    "life-dew"
  ],
  "moves": [
    "heal-bell",
    "ancient-power",
    "future-sight",
    "healing-wish",
    "life-dew",
    "wood-hammer",
    "branch-poke",
    "aromatherapy",
    "frenzy-plant",
    "kinesis",
    "flower-rush",
    "synchronize",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 129,
    "item": null,
    "species": [
      {
        "name": "celebi",
        "order": 276,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
